import { render, staticRenderFns } from "./RelateModal.vue?vue&type=template&id=5a3124d3&scoped=true"
import script from "./RelateModal.vue?vue&type=script&lang=js"
export * from "./RelateModal.vue?vue&type=script&lang=js"
import style0 from "./RelateModal.vue?vue&type=style&index=0&id=5a3124d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3124d3",
  null
  
)

export default component.exports